import * as angular from 'angular';
import * as app from './app';

export function bootstrap() {
    $(document).ready(function(){
        angular.bootstrap(document, ['app'], {strictDi: true});
    });
}
